module.exports = __webpack_public_path__ + "img/pix-dark.0a609ce1.svg";